import React from 'react';

const InvoicedComponentLoadable = React.lazy(() => import('./InvoicedComponent'));
export {
	InvoicedComponentLoadable,
};
